import { useState, useEffect, Component } from "react";
import MobileVersionNotAvailable from "./MobileVersionNotAvailable";

//define your thresholds to be used in all screens
const thresholdWidth = 100;
const thresholdHeight = 100;

export default function PreventRenderOnSmallScreen({
  children,
}: {
  children: any;
}) {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    
    function handleResize() {
      // Debounce the resize event to prevent re-render storm
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const { innerWidth, innerHeight } = window;
        const isSmallWidth = innerWidth < thresholdWidth;
        const isSmallHeight = innerHeight < thresholdHeight;

        setIsSmallScreen(isSmallWidth || isSmallHeight);
      }, 200); // 200ms debounce
    }

    // Initial check
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeoutId);
    };
  }, [thresholdWidth, thresholdHeight]);

  // Actually prevent rendering the expensive children tree when small,
  // instead of just hiding it with CSS.
  if (isSmallScreen) {
    return (
      <div className="flex h-full w-full">
        <RenderBlockedScreen />
      </div>
    );
  }

  return (
    <div className="flex h-full w-full">
      {children}
    </div>
  );
}

//put whatever you want to render if the render is blocked due to too small of a screen size
function RenderBlockedScreen() {
  return (
    // <div className="flex h-full w-full items-center justify-center text-xl font-poppins">
    //   This screen is currently only available on Desktops and Tablets!
    // </div>
    <MobileVersionNotAvailable />
  );
}
